import { render, staticRenderFns } from "./SharedBizs.vue?vue&type=template&id=128dc74e&lang=pug"
import script from "./SharedBizs.vue?vue&type=script&lang=js"
export * from "./SharedBizs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports